import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLoginPage() {
  const [form, setForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, form);
      localStorage.setItem("admin_token", res.data.token);
      localStorage.setItem("admin_user", res.data.username);
      toast.success("Logged in successfully");
      navigate("/admin");
    } catch {
      toast.error("Invalid credentials");
    }
    setLoading(false);
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center pt-20">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-sm px-6"
      >
        <div className="text-center mb-10">
          <div className="w-16 h-16 border border-white/20 flex items-center justify-center mx-auto mb-6">
            <Lock size={28} className="text-zinc-400" />
          </div>
          <h1 className="font-subheading text-2xl uppercase tracking-tight">Admin Login</h1>
        </div>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="font-subheading text-xs uppercase tracking-[0.15em] text-zinc-500 block mb-2">Username</label>
            <input
              data-testid="admin-username"
              required
              value={form.username}
              onChange={e => setForm({ ...form, username: e.target.value })}
              className="bc-input w-full"
              placeholder="Username"
            />
          </div>
          <div>
            <label className="font-subheading text-xs uppercase tracking-[0.15em] text-zinc-500 block mb-2">Password</label>
            <input
              data-testid="admin-password"
              type="password"
              required
              value={form.password}
              onChange={e => setForm({ ...form, password: e.target.value })}
              className="bc-input w-full"
              placeholder="Password"
            />
          </div>
          <button
            type="submit"
            data-testid="admin-login-btn"
            disabled={loading}
            className="w-full font-subheading text-sm uppercase tracking-widest bg-white text-black px-8 py-3.5 hover:bg-zinc-200 transition-colors duration-300 disabled:opacity-50"
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
